module.exports = __webpack_public_path__ + "img/Merkur-Logo-Sticky-White.f95639b3.svg";